import './style.scss';
import { DocumentFolder } from './module/documentFolder';
import { IssuanceDocumentFolderInfo } from 'views/utils/graphql/graphql';

type IssuanceDocumentFolderListPageProps = {
  items: Array<IssuanceDocumentFolderInfo | null>;
  onFolderSelect: (folder: IssuanceDocumentFolderInfo) => void;
};

export const IssuanceDocumentFolderListPage = ({ items, onFolderSelect }: IssuanceDocumentFolderListPageProps) => {
  const showList = items
    ?.filter((x) => (x ? true : false))
    .map((item) => <DocumentFolder key={item!.ID} folder={item!} onFolderSelect={onFolderSelect} />);
  return (
    <div className="deliveryDocument">
      <div className="deliveryDocument_wrapper">{showList}</div>
    </div>
  );
};
